class AttendanceController {
  constructor() {
    this.name = 'attendance';
  }
}

export default AttendanceController;



// WEBPACK FOOTER //
// ./client/app/components/attendance/attendance.controller.js